const useStyles = () => {
    const dateReadOnlySx = (theme) => {
        return {
            width: '10.625rem',
            p: theme.spacing(1),
            pl: theme.spacing(2),
            pr: theme.spacing(2),
            backgroundColor: theme.palette.grey['disabled-background'],
            color: '#586874',
            border: 'none',
            borderRadius: '4px',
            boxSizing: 'border-box',
            fontSize: theme.spacing(13/8),
        };
    };

    const dateErrorTextSx = (theme) => {
        return {
            ml: theme.spacing(0.25),
            fontSize: '0.8rem',
        };
    };

    const datePickTextFieldSx = {
        width: '10.625rem',
        '& > .MuiOutlinedInput-root': {
            fontSize: '0.8125rem',
        },
        '& .Mui-disabled': {
            backgroundColor: (theme) => theme.palette.grey['disabled-background'],
            color: '#586874',
            WebkitTextFillColor: 'unset',
            fontWeight: 400,
            '& fieldset': {
                border: 'none',
            },
        },
    };

    const dateLabelSx = (theme) => {
        return {
            fontSize: theme.spacing(13 / 8),
            fontWeight: 700,
        };
    };

    const selectSx = (theme) => {
        return {
            fontSize: theme.spacing(13 / 8),
            '&.Mui-disabled': {
                backgroundColor: theme.palette.grey['disabled-background'],
                color: '#586874',
                fontSize: '0.813rem',
                '> .MuiSelect-select': {
                    WebkitTextFillColor: 'unset',
                },
                '> .MuiOutlinedInput-notchedOutline': {
                    border: 'none',
                },
            },
            width: '10.625rem',
            [theme.breakpoints.down('xl')]: {
                width: '10.9rem',
            },
            [theme.breakpoints.down('lg')]: {
                width: '7.8rem',
            },
            '& .MuiSelect-icon.Mui-disabled': {
                display: 'none',
            },
        };
    };

    const amountInputSx = (theme) => {
        return {
            '& .MuiInputBase-root, & *.Mui-disabled': {
                fontSize: theme.spacing(13 / 8),
            },
        };
    };

    const descriptionInputSx = (theme) => {
        return {
            '& .MuiInputBase-root, & .MuiInputBase-root *.Mui-disabled': {
                fontSize: theme.spacing(13 / 8),
                borderRadius: '4px',
            },
            mr: theme.spacing(5),
            '& .MuiTextField-root': {
                width: '25rem',
            },
        };
    };

    const buttonBoxSx = (theme) => {
        return {
            width: '41.5rem',
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            mb: theme.spacing(3.125),
        };
    };

    const autopopSx = (theme) => {
        return {
            mt: theme.spacing(3),
        };
    };

    const discountAndTotalBoxSx = (theme) => {
        return {
            display: 'flex',
            flexDirection: 'column',
            gap: theme.spacing(1.5),
            mb: theme.spacing(7.5),
        };
    };

    const rowBoxSx = (theme) => {
        return {
            display: 'flex',
            flexDirection: 'row',
        };
    };

    const colBoxSx = (theme) => {
        return {
            display: 'flex',
            flexDirection: 'column',
            gap: theme.spacing(1.5),
            mb: theme.spacing(3),
        };
    };

    return {
        dateReadOnlySx,
        dateErrorTextSx,
        datePickTextFieldSx,
        dateLabelSx,
        selectSx,
        amountInputSx,
        descriptionInputSx,
        buttonBoxSx,
        autopopSx,
        discountAndTotalBoxSx,
        rowBoxSx,
        colBoxSx,
    };
};

export default useStyles;

